import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

import { Flex, Icon, Label, Text } from '@lucidhq/lucidium';
import {
  Field,
  useField,
  useFormikContext
} from '@lucidhq/lucidium/components/FormV2';

import { t } from '~/utils/i18n';

export const SampleSizeField = ({
  name,
  isDisabled = false
}: {
  name: string;
  isDisabled?: boolean;
}) => {
  const [value, meta] = useField(name);
  const {
    values: {
      draft_settings: {
        forced_exposure: { creatives_number }
      }
    }
  } = useFormikContext<{
    draft_settings: {
      forced_exposure: { creatives_number?: number };
    };
  }>();

  return (
    <Flex lss={{ flexDirection: 'column', my: 'md' }}>
      <Label lss={{ my: 'sm', mr: 'xxs' }} required htmlFor={name}>
        {t('forms.labels.sampleSize')}
      </Label>
      <Field
        data-testid="sample-size-field"
        name={name}
        type="number"
        step={200}
        disabled={isDisabled}
        placeholder={t(`forms.placeholders.sampleSize`)}
        value={value.value || ''}
        groupLss={{ pb: 'none', width: '100%' }}
        min="0"
      />
      {!meta.error && !!value.value && !!creatives_number && (
        <Flex lss={{ alignItems: 'center', gap: '8px', marginTop: '8px' }}>
          <Icon as={MdInfoOutline} size={16} />
          <Text lss={{ fontSize: '0.875rem' }}>
            {t('campaignManager.campaignDetails.tooltips.sampleSize', {
              sampleSize: value.value,
              totalPerCreative: value.value * 2,
              total: value.value * 2 * creatives_number,
              creativesNumber: creatives_number
            })}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
